export interface ApiConfig {
  subBaseUrlhttp: string;
}
